module.exports = __webpack_public_path__ + "img/bank.a4bfe4c6.svg";